export const ServiceUrls = {
  IDP_SERVICE: process.env.REACT_APP_IDP_SERVICE,
};

export const RegisterServiceUrls = {
  REGISTER_SERVICE: process.env.REACT_APP_REGISTER_SERVICE,
  GET_IPINFO_LOCATION: process.env.REACT_APP_GET_IPINFO_LOCATION,
};

export const BackEndServiceUrls={
  BACKEND_SERVICE : process.env.REACT_APP_BACKEND_SERVICE
}